// Hosted environments stay fixed. The local preview can explicitly opt into beta.
export const usesBetaApi = (hostname: string): boolean =>
  hostname === 'beta.thefableapp.com' ||
  (['localhost', '127.0.0.1', '[::1]'].includes(hostname) &&
    process.env.REACT_APP_USE_TEST_API === 'true');
